import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el libro?',
    a: 'Es un libro digital (PDF). Inmediatamente después de tu compra segura por $9.99, recibirás un correo electrónico con el enlace para descargarlo en tu celular, tablet o computadora. Puedes leerlo al instante.'
  }, {
    q: '¿Los ingredientes son difíciles de encontrar?',
    a: '¡Para nada! Todos los ingredientes están pensados para comprarse en supermercados comunes en Estados Unidos como Walmart, Aldi, Publix o Kroger. No necesitas ir a tiendas especializadas caras.'
  }, {
    q: 'Tengo más de 65 años, ¿estas recetas son seguras para mí?',
    a: 'Sí, están diseñadas específicamente para metabolismos maduros. Son bajas en sodio, ricas en nutrientes antiinflamatorios y fáciles de digerir para no interrumpir tu sueño.'
  }, {
    q: '¿Qué pasa si no me gusta el libro?',
    a: 'Tienes una garantía de 7 días. Si sientes que las recetas no son para ti, simplemente envíanos un correo y te devolveremos tu dinero sin hacer preguntas.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#5C3D2E] mb-12" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-5" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-[#D4A017]/30 rounded-2xl overflow-hidden bg-[#FFFDF5]" data-id="element-6">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-7">
        <span className="text-xl font-bold text-[#5C3D2E] pr-4" data-id="element-8">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-9">
          <ChevronDown className="w-6 h-6 text-[#D4A017] flex-shrink-0" data-id="element-10" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-11">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-12">
            <div className="px-6 pb-5 text-lg text-[#5C3D2E] opacity-90 border-t border-[#D4A017]/10 pt-4" data-id="element-13">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}